export const createStyles = (
  theme: any,
  isDark: boolean,
  actionColor: string | undefined,
  groupListMaxHeight: number
) => ({
  filterButton: {
    bgcolor: 'background.paper',
    borderColor: 'grey.400',
    borderRadius: 1,
    color: 'text.secondary',
    fontSize: '1rem',
    fontWeight: 400,
    height: '40px',
    justifyContent: 'space-between',
    minWidth: 0,
    px: 1.5,
    textTransform: 'none',
    width: '100%',
    '& .MuiButton-endIcon': { flexShrink: 0 },
    '&:hover': {
      bgcolor: 'background.paper',
      borderColor: 'primary.main',
    },
  },
  selectedLabel: { flex: 1, minWidth: 0, textAlign: 'left' },
  menuPaper: {
    '& .group-filter-option': { paddingBottom: '2px', paddingTop: '2px' },
    mt: 0.5,
    width: '240px',
  },
  groupList: { maxHeight: groupListMaxHeight, overflowY: 'auto' },
  groupSet: { minWidth: 0, px: 2, py: '6px' },
  groupSetText: {
    color: isDark ? '#FFFFFFDE' : '#000000DE',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: '0.1px',
    lineHeight: '157%',
  },
  groupOptionLabel: {
    minWidth: 0,
    width: '100%',
    '& .MuiFormControlLabel-root': { marginRight: 0 },
  },
  groupOptionText: { color: 'text.secondary', flex: 1, minWidth: 0 },
  footer: { pt: 0.5, width: '100%' },
  manageText: {
    color: isDark ? '#FFFFFFDE' : '#000000DE',
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: '0.1px',
    lineHeight: '157%',
  },
  clearContainer: { display: 'flex', justifyContent: 'flex-end' },
  clearText: {
    color: actionColor,
    fontFamily: theme?.typography?.fontFamily,
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: '0.1px',
    lineHeight: '157%',
  },
});
